import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/reviews/stats`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const states = {
  get: apiPathFunc(pathBase),
} as const;
